(ns frontend.view.components.timeline.entry.declaration)

(defmulti timeline-entry-view (comp :audit/op :entry))

